module.exports = __webpack_public_path__ + "static/media/Spinner.1388abb9.gif";